import { render, staticRenderFns } from "./EmailSenderSelect.vue?vue&type=template&id=185d2812&"
import script from "./EmailSenderSelect.vue?vue&type=script&lang=js&"
export * from "./EmailSenderSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports